import TabNav, { MenuItem } from "../../../components/navigation/TabNav";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";

const menuItems: MenuItem[] = [
    // {
    //     label: 'Información',
    //     path: 'info',
    //     permission: {
    //         group: 'user',
    //         action: 'edit'
    //     },
    // },
    {
        label: 'Permisos',
        path: 'permissions',
        permission: {
            group: 'user',
            action: 'edit_permissions'
        },
    },
];

const pageHeader = {
    title: "Editar Usuario",
    breadcrumb: [
        { name: 'Administración' },
        { name: 'Control de acceso' },
        { name: 'Usuarios', href: menuRoutes.users.path },
        { name: 'Editar Usuario' },
    ],
};

export default function UserEditLayout({ children }: { children: React.ReactNode }) {

    // RENDER
    
    return (
        <>
            <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb} />
            <TabNav menuItems={menuItems} rootPath={'/edit'} />
            <div className="bg-white shadow-sm rounded-lg p-4 mt-4">
                {children}
            </div>
        </>
    )
};